import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("jjl_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const LOGO_URL = "/jjl-logo.png";

export function fmtIDR(n) {
  return "Rp " + (Number(n) || 0).toLocaleString("id-ID");
}

export function apiError(e, fallback = "Terjadi kesalahan. Coba lagi.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
